import { render, staticRenderFns } from "./HeaderPortadaForm.vue?vue&type=template&id=4c241a24&"
import script from "./HeaderPortadaForm.vue?vue&type=script&lang=js&"
export * from "./HeaderPortadaForm.vue?vue&type=script&lang=js&"
import style0 from "./HeaderPortadaForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports